import { CanActivate, Router } from "@angular/router"
import { HelpersService } from "../services/helpers.service"
import { ToastrService } from "ngx-toastr"

export class AdminGuard implements CanActivate {
	private canRoute: boolean

	constructor(
		private helpersService: HelpersService,
		private router: Router,
		private toastr: ToastrService
	) {}

	canActivate(): boolean {
		return this.isAdmin()
	}

	private isAdmin() {
		if (this.helpersService.isAdmin) {
			this.canRoute = true
		} else {
			this.canRoute = false
			this.router.navigateByUrl("/")
			this.toastr.error("Not Authorized", "", this.helpersService.toastrOptions)
		}
		return this.canRoute
	}
}
